import React, {useCallback, useEffect, useState} from 'react';
import MainLayout from "../../layouts/main";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import CategoryCell from "../../components/category-cell";
import {useCategoryService} from "../../services/category-service";
import Loading from "../../components/loading";
import {AppRoutes, SearchTypes} from "../../utils/constants";


export default function Categories () {

  const [categories, setCategories] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [collapsed, setCollapsed] = useState({});
  const {addErrorMessage} = useGlobalNotificationMessage();

  const categoryService = useCategoryService();

  useEffect(() => {
    let promises = [
      categoryService.getList(),
    ];

    Promise.all(promises).then(async ([cats = []]) => {
      setCategories(cats?.groups.map((g, i)=>{
        g.handle = g.name?g.name:`group-${i}`;
        return g;
      }) || []);
      setLoaded(true);
    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage);
    });
  }, []);

  const toggleCollapsed = useCallback((handle) => {
    setCollapsed(prevState => {
      return {...prevState, [handle]: !prevState[handle]}
    });
  }, []);

  const CategoryGroupCard = React.memo(function CategoryGroupCard({group, callback=null, ...props}) { return <div className="card clickable mb-4 rounded-3 overflow-hidden hover-cell-effect" onClick={callback ? () => callback(group) : undefined}>
    <img alt='' src={group.cover} className="img-fit" style={{ height: '180px'}} />
    <div className="card-body">
      <h6>{group.name} <span className="mdi mdi-chevron-down"></span></h6>
    </div>
  </div>
  });

  return (
    <>

      <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-sm-12 col-md-7 col-lg-6"}>
              <h1 className="header-stripe-blue">Categories</h1>
              <p>Pick category you find interesting</p>
            </div>
          </div>
        </div>
      </Section>

      {!loaded && <Loading />}

      {loaded && <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-sm-12"}>
              <div className="row">

                {categories?.length > 0 && <>
                  {categories.map((g,i) => <React.Fragment key={g.handle}>
                    {g.name && g.categories.length > 0 && <>
                      <div className="col-sm-6 col-md-4">
                        <CategoryGroupCard group={g} callback={() => toggleCollapsed(g.handle)}/>
                      </div>
                      <div style={{marginTop:'-50px;'}} className={`row py-4 mb-5 rounded-4 bg-light accordion-collapse collapse ${(collapsed[g.handle] ? 'show' : '')}`}>
                        {g.categories.length > 0 && g.categories.map(c => <div className="col-sm-6 col-md-3" key={g.handle + '_' + c.id}>
                          <CategoryCell category={c} link={`${AppRoutes.searchEvents.path}?type=${SearchTypes.discover}&categories=[CID]`}/>
                        </div>)}
                      </div>
                    </>}
                    {!g.name && g.categories.length > 0 && <>
                      {g.categories.length > 0 && g.categories.map(c => <div className="col-sm-6 col-md-4" key={g.handle + c.id}>
                        <CategoryCell category={c} link={`${AppRoutes.searchEvents.path}?type=${SearchTypes.discover}&categories=[CID]`}/>
                      </div>)}
                    </>}
                  </React.Fragment>)}
                </>}

                {categories?.length === 0 &&
                    <div className="text-muted p-5 text-center">We could not retrieve any categories. Please try again.</div>}
              </div>
            </div>
          </div>
        </div>
      </Section>}

    </>
  );
}

Categories.getLayout = function getLayout(page) {
  return (
      <MainLayout>
        {page}
      </MainLayout>
  )
}